export const APIEndpoints = {
    // Auth APIs
    login: '/login',
    register: '/register',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',

    // User management APIs
    getUsers: '/admin/users',
    createUser: '/admin/create-user',
    blockedUser: (id) => `/admin/users/${id}/block`,
    unblockedUser: (id) => `/admin/users/${id}/unblock`,

    // Subjects APIs
    getSubjects: '/subjects',
    
    // modal-answer upload api
    uploadAnswer: '/admin/model-answer',
    getModalAnswer: '/admin/model-answers',
    
    // past-modal-answer upload api
    uploadPastModelAnswer: '/admin/past-model-answer',
    getPastModelAnswers: '/admin/past-model-answers',
    
    // Submissions APIs
    getSubmissions: '/admin/submissions',
    getSubmissionDetails: '/admin/submissions',
    getResultDetails:(id) => `/admin/submissions/${id}/ai-results`,
    

    // Status APIs
    updateStatus: (submissionId) => `/admin/submissions/${submissionId}/status`,
    
    // Flagged content APIs
    getFlag: '/admin/submissions/flagged',
    addFlag: (submissionId) => `/admin/submissions/${submissionId}/flag`,
    removeFlag: (submissionId) => `/admin/submissions/${submissionId}/unflag`,

    // Profile APIs
    getProfile: '/admin/profile',
    updateProfile: (id) => `/admin/update-profile/${id}`,

    // AI Results APIs
    updateAIResult: (id) => `/admin/submissions/${id}/override-ai-results`,


    // Past Modal Answer APIs
    getPastModalAnswer: '/past-model-answers',
    uploadPastModalAnswer: '/past-model-answers',
    deletePastModalAnswer: (id) => `/past-model-answers/${id}`,

    // Plans APIs
    getPlans: '/admin/plans',
    createPlan: '/admin/plans',
    updatePlan: (id) => `/admin/plans/${id}`,
    deletePlan: (id) => `/admin/plans/${id}`,

    // Subscriptions APIs
    getPurchases: '/essay-purchases/admin/purchases',
  
};